/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Directive, ViewContainerRef, OnInit } from '@angular/core';

import { PopupService } from './popup.service';
import { ILoggerService } from '@touchplan/logging';
import { LoggerServiceFactory } from '../logging/LoggerServiceFactory';

//to create a new anchor point
// - open parent component, provide an instance of the popup.service
// - include 	<ng-template popup-anchor></ng-template> in the template where you want the popup
@Directive({
	selector: '[popup-anchor]',
	// providers: [PopupService]
})
export class PopupAnchor implements OnInit {
	private logger: ILoggerService;
	constructor(public viewContainerRef: ViewContainerRef, private popupService: PopupService) {
		//this works for now, it won't if we ever need to modify it with arguments for some reason. Since they won't have loaded yet
		this.popupService.anchor = this;
		this.logger = LoggerServiceFactory.create('PopupAnchor');
	}

	public ngOnInit() {
		this.logger.log('anchor init');
	}
}
